export default "__VITE_ASSET__DUgKaik___"